import { useEffect, useState } from "react";

const EMBED_SCRIPT = "https://link.msgsndr.com/js/form_embed.js";

// Live GoHighLevel qualification survey inside the #qualify card. Loads
// form_embed.js at most once (src-based guard shared with GhlCalendar),
// shows a subtle skeleton in card colors until the iframe is ready, and
// lets form_embed.js drive the height — no min-height after load, so the
// frame hugs each survey slide (short questions, taller contact step).
// `sandbox` (optional): pass a sandbox string to stop the survey from
// navigating the whole page after submit (used by the /military video gate so
// the visitor stays to watch; the regular survey card keeps GHL's redirect).
export default function GhlSurvey({ src, iframeId, title, testId, sandbox }) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (document.querySelector(`script[src="${EMBED_SCRIPT}"]`)) return;
    const s = document.createElement("script");
    s.src = EMBED_SCRIPT;
    s.type = "text/javascript";
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <div className="relative w-full" data-testid={testId}>
      {!loaded && (
        <div
          className="absolute inset-0 flex flex-col items-center justify-center gap-5 px-6"
          data-testid="survey-skeleton"
          aria-hidden="true"
        >
          <div className="h-4 w-2/3 animate-pulse rounded bg-ink-800" />
          <div className="h-4 w-1/2 animate-pulse rounded bg-ink-800" />
          <div className="mt-4 flex w-full max-w-md flex-col gap-3">
            <div className="h-12 w-full animate-pulse rounded-md bg-ink-800/80" />
            <div className="h-12 w-full animate-pulse rounded-md bg-ink-800/80" />
            <div className="h-12 w-full animate-pulse rounded-md bg-ink-800/80" />
          </div>
          <div className="mt-4 h-12 w-48 animate-pulse rounded-full bg-brand/30" />
        </div>
      )}
      <iframe
        src={src}
        id={iframeId}
        title={title}
        scrolling="no"
        sandbox={sandbox}
        onLoad={() => setLoaded(true)}
        className={`w-full rounded-lg transition-opacity duration-500 ${
          loaded ? "opacity-100" : "h-[420px] opacity-0 md:h-[460px]"
        }`}
        style={{ border: "none", width: "100%", background: "transparent" }}
      />
    </div>
  );
}
